import { render, staticRenderFns } from "./legendSnowMountain.vue?vue&type=template&id=7b7033fe&scoped=true"
import script from "./legendSnowMountain.vue?vue&type=script&lang=ts"
export * from "./legendSnowMountain.vue?vue&type=script&lang=ts"
import style0 from "./legendSnowMountain.vue?vue&type=style&index=0&id=7b7033fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7033fe",
  null
  
)

export default component.exports